module.exports = __webpack_public_path__ + "06fee13c48e68fed09d4c69e742a907c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/keurig_dr_pepper_2022_chart.png
// module id = 1682
// module chunks = 0